
window.addEventListener("load", (event) => {

var acc = document.getElementsByClassName("accordion");
var i;

for (i = 0; i < acc.length; i++) {
  acc[i].addEventListener("click", function() {
    /* Toggle between adding and removing the "active" class,
    to highlight the button that controls the panel */
    this.classList.toggle("active");

    /* Toggle between hiding and showing the active panel */
    var panel = this.nextElementSibling;
    if (panel.style.display === "block") {
      panel.style.display = "none";
    } else {
      panel.style.display = "block";
    }
  });
}

     $('.footer-block__heading.inline-richtext').click(function() {
                $(this).next('.footer-block__details-content.list-unstyled').toggleClass('active');
                 $(this).next('.footer__newsletter').toggleClass('active');
            });



             $('.cstm-list').click(function() {
      
        $('.grid.product-grid').removeClass('activeas');
    
        $('.grid.product-grid').addClass('activeas');
  
   });
      $('.cstm-grid').click(function() {
      
        $('.grid.product-grid').removeClass('activeas');
  
   });



  

 let items = document.querySelector(".header__inline-menu").querySelectorAll("details");
  console.log(items)
  items.forEach(item => {
    item.addEventListener("mouseover", () => {
      item.setAttribute("open", true);
      item.querySelector("ul").addEventListener("mouseleave", () => {
        item.removeAttribute("open");
      });
    item.addEventListener("mouseleave", () => {
      item.removeAttribute("open");
    });
  });
  
  });



    window.onload = function() {
    var element = document.querySelector('.product-recommendations--loaded .cstm-rlated');
    if (element) {
        element.classList.add('active');
    }
};

setTimeout(function() {
    var btn = document.querySelector(".related-products__heading");
    var slide1 = document.querySelector(".cstm-rlated");
    var btn2 = document.querySelector(".recent-view-heading");
    var slide2 = document.querySelector("#shopify-section-template--22769174151469__product_recommend_sec_Qb97Fk");

    // Ensure slide1 is active initially
    if (slide1) {
        slide1.classList.add('active');
    }

    btn.addEventListener("click", function() {
        if (slide1) {
            slide1.classList.add("active"); 
        }
        if (slide2) {
            slide2.classList.remove("active");
        }
    });

    btn2.addEventListener("click", function() {
        if (slide2) {
            slide2.classList.add("active"); 
        }
        if (slide1) {
            slide1.classList.remove("active");
        }
    });

}, 4000);







  





  

 })

  